import { render, staticRenderFns } from "./FeedbackRow.vue?vue&type=template&id=b33590fc&scoped=true"
import script from "./FeedbackRow.vue?vue&type=script&lang=js"
export * from "./FeedbackRow.vue?vue&type=script&lang=js"
import style0 from "./FeedbackRow.vue?vue&type=style&index=0&id=b33590fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33590fc",
  null
  
)

export default component.exports